import React from 'react';
import styles from './ErrorComponent.module.css';

const ErrorComponent = ({ errorMessage }) => {
    if (!errorMessage) return null;

    return (
        <div className={styles.errorContainer}>
            <p className={styles.errorMessage}>{errorMessage}</p>
        </div>
    );
};

export default ErrorComponent;
